mutation setUserEmailSignature($emailSignature: String, $userId: ID) {
    updateUserEmailSignature(
        input: {userEmailSignature: {emailSignature: $emailSignature, userId: $userId}}
    ) {
        user {
            id
            emailSignature
        }
    }
}
